import cn from 'classnames';

import MealCardLabel from 'components/common/MealCardLabel';
import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import { textTags } from 'lib/constants';
import * as Types from 'utilities/types';

const MealTags = ({
  displayPrep = true,
  renderGradient = true,
  textClass = '',
  meal: { dietaryTags = [], prepMinutes, mealPlanSlug },
}) => {
  const isTempo = useBrand(TEMPO) || mealPlanSlug === TEMPO;

  const texts = dietaryTags
    .map(tag => {
      const textTag = textTags(isTempo)[tag];
      return textTag ? { ...textTag, tag } : null;
    })
    .filter(Boolean);

  return (
    <span className="relative mt-auto flex flex-nowrap items-stretch overflow-hidden">
      {prepMinutes && !isTempo && displayPrep && (
        <p className={cn(textClass, 'textSm mt-2 pr-2 font-normal text-charcoal-90')}>
          {prepMinutes} MIN
        </p>
      )}
      {texts.length > 0 && (
        <span className="mt-2 flex w-1 items-center gap-x-1 gap-y-1 whitespace-nowrap">
          {texts.map(({ text, tag }) => (
            <MealCardLabel key={tag} text={text} />
          ))}
        </span>
      )}
      {renderGradient && (
        <span className="absolute bottom-0 right-0 top-0 w-6 bg-gradient-to-l from-white-100 to-transparent" />
      )}
    </span>
  );
};

MealTags.propTypes = {
  meal: PropTypes.oneOfType([Types.meal, Types.lineItemMeal]).isRequired,
  textClass: PropTypes.string,
  displayPrep: PropTypes.bool,
  renderGradient: PropTypes.bool,
};

export default MealTags;
